import { useEffect, useState } from 'react';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
} from 'firebase/firestore';
import { firestore } from '../services/firebase';

export function useGlobalFilters({ enabled = true } = {}) {
  const [filters, setFilters] = useState([]);
  const [prefilterByTagFirst, setPrefilterByTagFirst] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const [settingsSnap, filtersSnap] = await Promise.all([
          getDoc(doc(firestore, 'customization', 'settings')),
          getDocs(query(collection(firestore, 'filters'), orderBy('order', 'asc'))),
        ]);

        if (cancelled) return;

        if (settingsSnap.exists()) {
          setPrefilterByTagFirst(!!settingsSnap.data().prefilterByTagFirst);
        } else {
          setPrefilterByTagFirst(false);
        }

        const list = filtersSnap.docs
          .map((docSnap) => {
            const data = docSnap.data();
            return {
              id: docSnap.id,
              name: data.name,
              slug: data.slug,
              order: data.order,
              archived: !!data.archived,
            };
          })
          .filter((item) => !item.archived && item.slug);

        setFilters(list);
      } catch (err) {
        console.error('Erro ao carregar filtros globais:', err);
        if (!cancelled) {
          setFilters([]);
          setPrefilterByTagFirst(false);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { filters, prefilterByTagFirst, loading };
}
